export default "__VITE_ASSET__ccef270e__"